import { enrichAcpPermissionRpcResultFromRequestParams } from '../../enrich-acp-permission-rpc-result.js';
import type { JsonRpcRequestId, PendingRequest } from './cursor-json-rpc-types.js';

export function resolveCursorIncomingRequest(
  pendingRequests: Map<JsonRpcRequestId, PendingRequest>,
  respond: (id: JsonRpcRequestId, result: unknown) => void,
  requestId: JsonRpcRequestId,
  result: unknown,
): void {
  const pending = pendingRequests.get(requestId);
  const payload =
    pending?.method === 'session/request_permission'
      ? enrichAcpPermissionRpcResultFromRequestParams(result, pending.params)
      : result;
  respond(requestId, payload);
  pendingRequests.delete(requestId);
}
